import React, { FC } from "react";
import { useFormContext } from "react-hook-form";

import { Button, Container, Image, Typography } from "ui-library/atoms";
import { Box, ContentBox, Flexbox, Section } from "ui-library/layouts";
import { LabelTextItem } from "ui-library/modules";

import laptopImage from "assets/campaign/1440x490_Laptop.png";

import i18n from "core/i18n";
import { Field } from "core/hookForm";
import { ElectronicCommunicationCampaign } from "types";

import { CampaignElCommunicationFormValues } from "../types/CampaignElCommunicationFormValues";

interface CampaignFormProps {
    campaignData: ElectronicCommunicationCampaign;
    isProcessing: boolean;
    onSubmit: (data: CampaignElCommunicationFormValues) => void;
}

export const CampaignForm: FC<CampaignFormProps> = ({ campaignData, isProcessing, onSubmit }) => {
    const { t } = i18n.useTranslation();
    const { handleSubmit, watch } = useFormContext<CampaignElCommunicationFormValues>();

    const isAgreementChecked = watch("agreement");

    return (
        <>
            <Flexbox direction={{ lg: "row" }} justifyContent={"center"} mb={5}>
                <Box sx={{ width: 960 }}>
                    <Image borderRadius={0} alt={"table"} src={laptopImage} shadow={false} />
                </Box>
            </Flexbox>

            <Container maxWidth="md">
                {/* Title */}
                <Section>
                    <Typography variant="h1">{t("form.campaignElectronicCommunication")}</Typography>
                </Section>

                {/* Introduction text */}
                <ContentBox mb={3}>
                    <Typography component="p" markDown={t("form.campaignElectronicCommunication.text")} />
                </ContentBox>

                {/* Product specific data */}
                <ContentBox mb={5}>
                    <LabelTextItem label={t("common.contractNumber")} text={campaignData.contractNumber} />
                    <LabelTextItem label={t("common.insuranceType")} text={campaignData.productCrm} />
                    <LabelTextItem label={t("holder.emailAddress")} text={campaignData.email} />
                </ContentBox>

                {/* Check with footnote */}
                <ContentBox mb={5}>
                    <Field<CampaignElCommunicationFormValues>
                        name="agreement"
                        input="switch"
                        label={t("form.campaignElectronicCommunication.agreementField")}
                        footNote={t("form.campaignElectronicCommunication.footNote")}
                        disabled={isProcessing}
                    />
                </ContentBox>

                {/* Submit button */}
                <Flexbox direction={{ lg: "row" }} justifyContent={"center"} gap={2} mb={10}>
                    <Button color="green" size="large" onClick={handleSubmit(onSubmit)} disabled={!isAgreementChecked || isProcessing}>
                        {t("form.campaignElectronicCommunication.submit")}
                    </Button>
                </Flexbox>
            </Container>
        </>
    );
};
